export default function findObjectTypeIdsAssociatedTo(objectTypeId, associationDefinitionsQuery) {
  return associationDefinitionsQuery.data.allDefinitions.filter(assoc => assoc.fromObjectTypeId === objectTypeId).map(assoc => assoc.toObjectTypeId);
}